import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DISCONNECT_INTEGRATION } from '../documents';
import {
  DisconnectIntegrationInput,
  IntegrationConnection,
  IntegrationWorkspaceVariables,
} from '../types';
import { integrationConnectionsCacheKey } from './cacheKeys';
import {
  integrationAuthError,
  useIntegrationAuthFetcher,
} from './useIntegrationAuthFetcher';

interface DisconnectResponse {
  integrationAuth: { disconnectConnection: IntegrationConnection } | null;
}

export const useDisconnectIntegration = (workspaceId: string | undefined) => {
  const queryClient = useQueryClient();
  const fetcher = useIntegrationAuthFetcher<
    DisconnectResponse,
    DisconnectIntegrationInput & IntegrationWorkspaceVariables
  >(DISCONNECT_INTEGRATION);
  return useMutation({
    retry: false,
    mutationFn: async (
      input: DisconnectIntegrationInput
    ): Promise<IntegrationConnection> => {
      if (!workspaceId) throw integrationAuthError();
      const data = await fetcher({ ...input, workspaceId });
      if (!data.integrationAuth) throw integrationAuthError();
      return data.integrationAuth.disconnectConnection;
    },
    onSuccess: async (connection: IntegrationConnection): Promise<void> => {
      await queryClient.invalidateQueries({
        queryKey: integrationConnectionsCacheKey(connection.workspaceId),
      });
    },
  });
};
